import { SelectorsApp } from './components/App';
import reducers from './reducers';
import middlewares from './middlewares';

export { SelectorsApp, reducers, middlewares };



// WEBPACK FOOTER //
// ./src/index.js